"use client";
import FollowTable from "@/components/bettor/follow-table";
import Card from "@/components/primitives/card";
import NotFound from "@/components/primitives/not-found";
import { PageSizes } from "@/components/primitives/table-pagination";
import Tabs from "@/components/primitives/tabs";
import { useQueryUpdater } from "@/utils/hooks/navigation";
import { BettorRelationshipsModel, PaginatedResponse } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export interface FollowingSearchParams {
  view?: "following" | "followers";
  limit?: PageSizes;
  page?: string;
}

export default function FollowingContainer({
  data,
  params,
  searchParams,
}: {
  data: PaginatedResponse<BettorRelationshipsModel>;
  params: { username: string };
  searchParams: FollowingSearchParams;
}) {
  const router = useRouter();
  const { createQueryParamString } = useQueryUpdater();

  const view: string = searchParams.view || "followers";
  const onPageChange = (newPage: number) => {
    router.replace(createQueryParamString("page", newPage.toString()), {
      scroll: false,
    });
  };

  const onPageSizeChange = (newSize: number) => {
    router.replace(createQueryParamString("limit", newSize.toString()), {
      scroll: false,
    });
  };

  return (
    <Card
      header={{
        title: `Bettors ${searchParams.view || "followers"}`,
        action: (
          <Tabs
            label="following"
            value={view}
            items={[
              {
                label: "Followers",
                value: "followers",
              },
              {
                label: "Following",
                value: "following",
              },
            ]}
            onValueChange={(v: string) =>
            {

              router.replace(createQueryParamString("view", v), {
                scroll: false,
              })
              router.refresh();
            }
            }
          />
        ),
      }}
    >
      {data && data.rows.length > 0 ? (
        <FollowTable
          data={data.rows}
          pagination={{
            size: Number(searchParams.limit || 10),
            page: Number(searchParams.page || 1),
            count: data?.pagination.totalCount || 0,
            onPageChange: onPageChange,
            onPageSizeChange: onPageSizeChange,
          }}
        />
      ) : (
        <>
          {searchParams.view === "following" ? (
            <NotFound
              label="This user isn't following anyone"
              caption="When they do follow someone, they'll show up here."
            />
          ) : (
            <NotFound
              label="This user isn't followed by anyone"
              caption="When someone follows them, they'll show up here."
            />
          )}
        </>
      )}
    </Card>
  );
}
